import { c as _c } from "react/compiler-runtime";
import React, { useEffect, useRef, useState } from 'react';
import { useIntersection } from 'react-use';
import BVReviews from 'components/consumer/PDP/BazaarVoice/BVReviews';
import { onBvShowReviews } from 'hooks/useBazaarVoice';
import usePdpFullVariantSku from '../state/pdpFullVariantSku/usePdpFullVariantSku';
const PDPCustomerPhotos = () => {
  const $ = _c(8);
  const variantSku = usePdpFullVariantSku();
  const containerRef = useRef(null);
  const [forceMountReviews, setForceMountReviews] = useState(false);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = {
      rootMargin: "600px 0px"
    };
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  const intersection = useIntersection(containerRef, t0);
  const hasApproachedViewport = intersection?.isIntersecting;
  let t1;
  let t2;
  if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = () => onBvShowReviews(() => setForceMountReviews(true));
    t2 = [];
    $[1] = t1;
    $[2] = t2;
  } else {
    t1 = $[1];
    t2 = $[2];
  }
  useEffect(t1, t2);
  const shouldMountReviews = hasApproachedViewport || forceMountReviews;
  let t3;
  if ($[3] !== shouldMountReviews || $[4] !== variantSku) {
    t3 = shouldMountReviews && <BVReviews key={variantSku} productId={variantSku} />;
    $[3] = shouldMountReviews;
    $[4] = variantSku;
    $[5] = t3;
  } else {
    t3 = $[5];
  }
  let t4;
  if ($[6] !== t3) {
    t4 = <div ref={containerRef} className="[border-top:1px_solid_#e5e5e5] mt-14 pt-14 min-h-[400px]" id="PDPCustomerPhotos">{t3}</div>;
    $[6] = t3;
    $[7] = t4;
  } else {
    t4 = $[7];
  }
  return t4;
};
export default PDPCustomerPhotos;